import React, { Component } from "react";
import PropTypes from "prop-types";

export default class BaseCancellationModal extends Component {
	static propTypes = {
		children: PropTypes.instanceOf(Object).isRequired,
		open: PropTypes.bool.isRequired,
	};

	render() {
		return (
			<div
				className={`cancellation-modal tingle-modal ${
					this.props.open ? "tingle-modal--visible" : ""
				}`}
			>
				<div className="tingle-modal-box cancellation-modal-box">
					{this.props.children}
				</div>
			</div>
		);
	}
}
